export default {
  learnMore: 'Learn more',
  klarnaLogoTitle: 'Klarna',
  steps: {
    addItemToCart: 'Add items(s) to your cart',
    chooseKlarna: 'Go to checkout and choose',
    enterInformation: 'Enter your debit or credit card information',
  },
  ca: {
    title: '4 interest-free payments of {{installmentAmount}}.',
    additionalSteps: {
      explainPaymentPlan: 'The first payment is taken when the order is processed and the next 3 payments are automatically charged every 2 weeks.',
    },
    terms: 'View the Privacy Notice and Klarna Shopping Service terms {{linkOpen}}here.{{linkClose}}.',
  },
  es: {
    title: '3 interest-free payments of {{installmentAmount}}.',
    additionalSteps: {
      explainPaymentPlan: 'Pay later over 3 installments. The first payment is taken when the order is processed and the remaining 2 are automatically taken every 30 days.',
    },
    terms: 'Please note that a higher initial payment may be required for some purchases. More information in the Pay later over 3 installments complete {{linkOpen}}terms{{linkClose}}.',
  },
  fr: {
    title: '3 interest-free payments of {{installmentAmount}}.',
    additionalSteps: {
      explainPaymentPlan: 'The first payment is taken when the order is processed and the remaining 2 are automatically taken every 30 days.',
    },
    terms: 'Pay later in 3 installments {{linkOpen}}complete terms{{linkClose}}.',
  },
  gb: {
    title: '3 interest-free payments of {{installmentAmount}}. No fees.',
    additionalSteps: {
      checkEligibility: 'To check your eligibility, Klarna will perform a soft search with a credit reference agency. This will not affect your credit score.',
      explainPaymentPlan: 'Spread the cost in 3 interest-free payments. The first payment is made at point of purchase, with the remaining 2 payments scheduled automatically every 30 days. No fees.',
    },
    terms: 'You must be 18+ to use this credit offer. Klarna uses soft searches with credit reference agencies. These do not affect your credit rating. Missed payments can affect your ability to use Klarna. Pay in 3 complete {{linkOpen}}terms{{linkClose}}.',
  },
  it: {
    title: '3 interest-free payments of {{installmentAmount}}.',
    additionalSteps: {
      explainPaymentPlan: 'Pay later over 3 installments. The first payment is taken when the order is processed and the remaining 2 are automatically taken every 30 days.',
    },
    terms: 'Please note that a higher initial payment may be required for some purchases. More information in the Pay later over 3 installments complete {{linkOpen}}terms{{linkClose}}.',
  },
};
